export const ABOUT_CONST = {
    GET_ABOUT: "GET_ABOUT",
  };
  